const styles = theme => ({})

export default styles



// WEBPACK FOOTER //
// ./src/components/CountUp/styles.js